import { AssumptionsContainer } from '@/components/Assumption';
import { Route } from '@/routes/estimation/detail/$estimationId/$tabId';

import { Layout } from '../../Layout';

const EstimationDetailAssumptionsTab = () => {
  const { estimationId } = Route.useLoaderData();

  return (
    <Layout>
      <AssumptionsContainer estimationId={estimationId} />
    </Layout>
  );
};

export default EstimationDetailAssumptionsTab;
